import { render } from "./ResumeView.vue?vue&type=template&id=48b1a9fa&scoped=true"
import script from "./ResumeView.vue?vue&type=script&lang=js"
export * from "./ResumeView.vue?vue&type=script&lang=js"

import "./ResumeView.vue?vue&type=style&index=0&id=48b1a9fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b1a9fa"]])

export default __exports__